module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANdJREFUeNpi9PDw+M/AwHABiA2YGCDAAETAOGAAEECMUGUQAOIwwUQAAghVCgqYGLAAgABCVhkIxOvRVa6Hq0S2CcZmIdoigADC5qTAHTt2bEAXZwERQAlGdBNAYsiKsVqD7kC4ibgkoaARiOsZiAUAAYTVM1ATDPAGBcjHUOsYcLoRjztxBw9G1BBrIjY3MuK0GpcpGCaCTMFlEiwEGIkxjSQAEGDEmBgIjQSQXwKQkzhOTxMA9UCD4GxCiokx0ICQqwhmN0rAqIFkgUbkfM1CBQPraeplAPI/RyyIqr9lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/shangye.png
// module id = VpoR
// module chunks = 1